<div data-upvoty id="upvoty-widget" class="show" style="opacity: 0; right: -100vw" *ngIf="isVisible">
  <button class="btn btn-yellow" id="upvoty-widget-button" (click)="toggleAppearance($event.target)">
    <app-svg source="icons/feather/megaphone" height="18"></app-svg>
    Feedback
  </button>
</div>